import { ICheckboxSelectOption } from 'src/components/filter/types/filter.types'

export const defaultTranslationsLimit = 50
export const defaultPage = 0
export const defaultSort = 'namespace-asc'

export const translationsSortOptions = [
  {
    label: 'sort-name-asc.v',
    value: 'namespace-asc',
  },
  {
    label: 'sort-name-desc.v',
    value: 'namespace-desc',
  },
  {
    label: 'sort-value-asc.v',
    value: 'value-asc',
  },
  {
    label: 'sort-value-desc.v',
    value: 'value-desc',
  },
]

export const translationsChecboxOptions: ICheckboxSelectOption[] = [
  {
    label: 'missing-translations-checkbox-label',
    queryParamName: 'onlyMissing',
  },
  {
    label: 'translations-review-checkbox-label',
    queryParamName: 'reviewRequired',
  },
]
